import { useEffect } from 'react';

import {
  useGetApiUserSettingsQuery,
  useLazyGetApiLocalesByLocaleIdQuery,
} from 'shared/api/gsp';
import { useDefaultLocale } from 'shared/hooks/localization';

export const useGetTranslation = () => {
  const { isLoading: isUserSettingsLoading } = useGetApiUserSettingsQuery();
  const [getTranslation, { isLoading: isTranslationsLoading }] =
    useLazyGetApiLocalesByLocaleIdQuery();
  const localeId = useDefaultLocale();

  useEffect(() => {
    if (!isUserSettingsLoading && localeId) {
      getTranslation({ localeId });
    }
  }, [getTranslation, isUserSettingsLoading, localeId]);

  return { isLoading: isUserSettingsLoading || isTranslationsLoading };
};
